import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { useConfirmConceptJobMutation, useFindConceptJobQuery } from "../../../../newapi/pickingjob/pickingjobSlice";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../utils/toasts";
import { tokens } from "../../../../theme";
import SHModalBottom from "../../../theme/Modal/SHModalBottom";
import Subheading from "../../../theme/text/Subheading";
import { CheckBatchBody, CheckBatchFooter } from "./views/CheckBatchView";
import { MConfirmEditBatch } from "./MConfirmEditBatch";
import { addAction } from "../../../../newapi/global/actionProgressSlice";
import { useDispatch } from "react-redux";

const defaultCreateBatchStructure = (t) => {
    
    return {
        'user': { 
            id:-1,
            name:t("no_selection")
        },
        'shipper':  {
            id:-1,
            name: t("all")
        },
        'shipperProfile':  {
            id:-1,
            name: t("all")
        },
        'reachtype': {
            id:-1,
            name: t("all")
        },
        'relation': {
            id:-1,
            name: t("all")
        },
        'stream': {
            id:-1,
            name: t("no_selection")
        },
        'cart': {
            id:-1,
            barcode: t("no_selection")

        },
        'product' : [],
        'warehousezone': [],
        'warehouse': {
            id:-1,
            name: t("no_selection")
        },
    }
};


export const MEditBatch = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const {data, isLoading, isFetching} = useFindConceptJobQuery(props.id,{skip:!props.id && !props.open});
    const [confirmConceptJob, {isLoading: isConfirming}] = useConfirmConceptJobMutation();
    const [groupBy, setGroupBy] = useState("shipper");
    const [changes, setChanges] = useState({
        ordersToRemove: [],
        orderChanges: [],
    });

    useEffect(() => {
        if (props.open) {
            setChanges({
                ordersToRemove: [],
                orderChanges: [],
            });
        }
    }, [props.id, props.open]);

    const handleGroupByChange = (_event, value) => {
        if (value !== null) {
            setGroupBy(value);
        }
    };

    const handleClose = () => {
        setChanges({
            ordersToRemove: [],
            orderChanges: [],
        });
        props.handleClose();
    }

    const [mConfirmEditBatchOpen,setMConfirmEditBatchOpen] = useState(false);

    const handleSave = (options) => {
        const cleanedChanges = {
            ...options,
            ordersToRemove: changes.ordersToRemove,
            orderChanges: changes.orderChanges.map(({ id, shipperId, shipperProfileId }) => ({
                id,
                shipperId,
                shipperProfileId,
            })),
        };

        confirmConceptJob({
            jobId: props.id,
            ...cleanedChanges,
        })
        .unwrap()
        .then(res => {
            showToastMessagePostRequest(t, res);
            dispatch(addAction({
                type: "shipping_progress",
                entityType: "pickingjob", 
                entityId: props.id,
            }));
            handleClose();
        })
        .catch(err => {
            showToastMessageRequestError(t("confirm_failed"), t, err);
        });
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }



    return(
        <SHModalBottom
            open={props.open}
            onClose={handleClose}
            sx={{
                body: {
                    // your styles
                }
            }}
        >
            <Box
                sx={{
                    paddingY:3,
                    paddingX:3,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                }}
            >
                <Subheading>{t("check_batch")}</Subheading>
                <ToggleButtonGroup
                    value={groupBy}
                    exclusive
                    onChange={handleGroupByChange}
                    size="small"
                    sx={{
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        borderRadius: 5,
                        p:0.5,
                        '& .MuiToggleButtonGroup-grouped': {
                            border: 0,
                            px: 2,
                        borderRadius: 4,
                            py: 0.5,
                            fontFamily: "Roboto,sans-serif",
                            fontSize: 14,
                            fontWeight: 500,
                            textTransform: 'none',
                            '&.Mui-selected': {
                                background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                '&:hover': {
                                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                },
                            },
                            '&:not(.Mui-selected)': {
                                // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                                color: colors.txt["secondary"],
                            },
                        },
                    }}
                >
                    <ToggleButton value="shipper">{t("shipper")}</ToggleButton>
                    <ToggleButton value="relation">{t("relation")}</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    flex:1,
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    overflow:'hidden',
                    transition:"250ms"
                }}
            >
                <CheckBatchBody
                    job={data}
                    groupBy={groupBy}
                    changes={changes}
                    setChanges={setChanges}
                />
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >

                <CheckBatchFooter
                    handleChange={() => {setMConfirmEditBatchOpen(true)}}
                    isLoading={isConfirming}
                    goBack={handleClose}
                />

            </Box>

            <MConfirmEditBatch
                handleClose={(toContinue, options) => {
                    if(toContinue){
                        handleSave(options);
                    }
                    setMConfirmEditBatchOpen(false);
                }}
                open={mConfirmEditBatchOpen}
            />
        </SHModalBottom>
    )
}